import { render, staticRenderFns } from "./DataShowOff.vue?vue&type=template&id=4d469528"
import script from "./DataShowOff.vue?vue&type=script&lang=js"
export * from "./DataShowOff.vue?vue&type=script&lang=js"
import style0 from "./DataShowOff.vue?vue&type=style&index=0&id=4d469528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports